import React, { useContext } from 'react';
import Context from './Context';
import { PopSvg } from './PopSvg';
import PopMap from './PopMap';
import PopRelation from './PopRelation';
import PopMedia from './PopMedia';
import PopConnect from './PopConnect';
import PopKpi from './PopKpi';
import { closeObject, objRelationsInit, filterObjCardAttVal } from './PopObjectStruct';
import { selectObjRelatedNext, selectObjValues } from './PopApiGlobal';
import { PopObjectFolders } from './PopFolders';
import PopCardAttribute from './PopAttribute';

import { FILE_LOCATION, pop } from './PopConst';


function PopObjects() {
    const { globalState } = useContext(Context);
    const { navigation, data } = globalState;

    return (
        <div className="pop-objects-map">
            { navigation.showConnect && <PopConnect/> }            
            { navigation.showMap && <PopMap/> }
            { navigation.showRelation && <PopRelation/> }
            { navigation.showKpi && <PopKpi/> }
            { navigation.showMedia && <PopMedia/> }
            <div className="pop-objects">
                { data.objects.map((object, index)=> { return (
                    <PopObject object={object} key={'obj-' + object.objTypeId + '-' + object.objId} id={navigation.buildId}/>
                ) })}
            </div>  
        </div>
    )
}


function cardClass(navigation) {
    if (navigation.showSearchDetail) return "pop-object-cards-main-grid";
    return "pop-object-cards";
}



function PopObjectTitle(props) {
    const { globalState, globalDispatch } = useContext(Context);
    const { navigation, data } = globalState;

    const onClickFolders = (o) => {
        props.object.showFolders = !props.object.showFolders; 
        if (props.object.showFolders) props.object.objCards.forEach(objCard => objCard.showFolders = false);
        globalDispatch( { type: 'update-state', state: globalState });
    }
    const onClickRelations = (o) => {
        navigation.showRelation = true;
        navigation.showRelationDetail = true;      
        props.object.showDetail = false;  
        props.object.showFolders = false;
        data.relations.showType = pop.objType.person;
        data.relations.showLabel = 0;
        objRelationsInit(props.object, globalState);
        selectObjRelatedNext(data.relations.obj, globalState, globalDispatch);   
    }

    const onClickProfile = (o) => {
        selectObjValues(props.object.objTypeId, props.object.objId, globalState, globalDispatch);
    }


    return (
        <div className="pop-object-title" style = { { backgroundColor: "#"+ props.object.objType.objTypeColor } } >
            <div className = "pop-object-title-profile" onClick={onClickProfile}>
                { props.object.objProfile ? 
                <img src={FILE_LOCATION + props.object.objProfile} alt="profile"/> : 
                <PopSvg svg={props.object.objSvg}/> }
                <h2>{props.object.objName}</h2>
                { props.object.objHistorical && <PopSvg svg="rip" style={{ height: "20px"}} /> }
            </div>
            <div className = "pop-object-title-icons">
                { props.object.objTypeId === pop.objType.person &&  props.object.showDetail && <PopSvg svg="relation" onClick= {onClickRelations}/>}
                { props.object.showDetail && <PopSvg svg="folder" onClick= {onClickFolders}/> }
                <PopSvg svg={props.object.showDetail ? "hide" : "show"} onClick= {o => { props.object.showDetail = !props.object.showDetail; props.object.showFolders = false; globalDispatch( { type: 'update-state', state: globalState }); }}/>
                <PopSvg svg="close" onClick= {o => { closeObject(props.object, globalState.data.objects); globalDispatch( { type: 'update-state', state: globalState }); }}/>
            </div>
        </div> 
    )

}


function PopObjectCard(props) {
    const { globalDispatch, globalState } = useContext(Context);
    return (
    <div className="pop-object-card">
        <div className="pop-object-card-header" style = { { backgroundColor: "#"+props.objCard.card.cardColor } }>
            <PopSvg svg={ props.objCard.card.cardSvg }/>
            <h3>{props.objCard.card.cardName}</h3>
            <PopSvg svg="hide" onClick={() => { props.objCard.showDetail = false; globalDispatch( { type: 'update-state', state: globalState });} }/>
        </div>
        <div className="pop-card-fields-scroll">
            <div className="pop-card-fields">
                { filterObjCardAttVal(props.objCard).map(objAttVal => { return(
                    <PopCardAttribute {...props} key={'Att-'+props.objCard.card.cardId+'-'+objAttVal.att.attId+'-'+objAttVal.val.lastUpdate} level = { 0 } objAttVal = {objAttVal}/>)})}
            </div>
        </div>
    </div>);   
}


function PopObject(props) {
    const { globalState } = useContext(Context);
    const { navigation } = globalState;
    const shownCards = props.object.objCards.filter(objCard => objCard.showDetail);

return (
        <div className="pop-object">
            <PopObjectTitle {...props} />
            { props.object.showFolders && 
            <PopObjectFolders {...props } keyChilds = {'folder-' + props.object.objTypeId+'-'+props.object.objId}/>  }
            { props.object.showDetail && (shownCards.length > 0) &&
            <div className={ cardClass(navigation) }>
            { shownCards.map(objCard => { return ( 
                <PopObjectCard key={'Card-'+objCard.card.cardId} objCard={objCard} editMode = {navigation.editMode && props.object.editMode} showNull = {objCard.showNull}/>
             )})}    
 
            </div> }
        </div> );
}


export default PopObjects;


